import React, { Suspense, useEffect, useState } from "react";
import Facebook from "../Icons/facebook";
import InstagramFill from "../Icons/Instagram_Fill";
import Linkedin from "../Icons/Linkedin";
import TinyLogo from "../../assets/tiny_logo.svg";
import Slider from "react-slick";
import { SuspenseImg } from "../../helpers/SuspenseImg";
import { CONSTANTS } from "../../helpers/Constant";
import axios from "axios";
import Spinner from "../misc/spinner";
import moment from "moment";

const getFeedsUrl = axios.create({
  baseURL: "https://2mnordic-api.azurewebsites.net",
});

const MAX_LENGTH = 150;

const Feeds = () => {
  const [feedSource, setFeedSource] = useState([]);
  const [showSpinner, setShowSpinner] = useState(true);

  useEffect(() => {
    getFeedsUrl
      .get("/feed?pagesize=4")
      .then((response) => {
        setShowSpinner(false);
        setFeedSource(response.data);
      })
      .catch((error) => {
        setShowSpinner(false);
        console.log(error);
      });
  }, []);

  const renderFeedList = feedSource?.map((item) => (
    <div className="bg-white rounded-lg border border-Gray-150" key={item.id}>
      <a href={item.url} target="_blank" rel="noopener noreferrer">
        <div className="px-4 py-3 flex flex-row items-center justify-between">
          <div className="flex flex-row items-start">
            <img
              src={TinyLogo}
              alt=""
              title=""
              className="w-10 h-10 rounded-full border border-Gray-150 p-2"
            />
            <div className="pl-2">
              <span className="text-blue-800 font-semibold text-xs block">
                {CONSTANTS.COMPANY_NAME} Consulting
              </span>
              <span className="text-Gray-400 font-light text-xs block py-1">
                {moment(item.publishedAt).format("MMMM Do YYYY, h:mm a")}
              </span>
            </div>
          </div>
          <div className="">
            <Linkedin className="cursor-pointer text-blue-700" />
          </div>
        </div>
        <div className="pb-4">
          <Suspense
            fallback={
              <div className="text-center h-48 flex flex-col items-center	w-full">
                <Spinner />
              </div>
            }
          >
            <SuspenseImg
              alt=""
              className="mx-auto h-48	w-full object-contain	"
              src={item.thumbnail}
            />
          </Suspense>
        </div>
        <div className="px-6 pb-6 ">
          {item.text.length > MAX_LENGTH ? (
            <p className="text-xs text-Gray-400 font-light pt-3 break-all	">
              {`${item.text.substring(0, MAX_LENGTH)}...`}
              <span className="block text-right py-2 text-blue-200">
                Read more
              </span>
            </p>
          ) : null}
        </div>
      </a>
    </div>
  ));

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
      <section className="bg-Gray-50 md:py-24 py-12 hidden md:block">
        <div className="container sm:container md:container lg:container w-full mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <h2 className="brand-secondary-gradient text-3xl md:text-4xl font-semibold leading-normal font-avenirHeavy md:pb-0 pb-6">
              #feeds
            </h2>
            <div className="flex flex-row items-center">
              <span className="text-blue-800 text-sm font-light pr-3">
                Follow us on
              </span>
              <div className="bg-white rounded-lg px-3 py-3 mx-2 border border-Gray-150">
                <a
                  href="https://www.facebook.com/2MNordic"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Facebook"
                >
                  <Facebook className="cursor-pointer text-blue-600" />
                </a>
              </div>
              <div className="bg-white rounded-lg px-3 py-3 mx-1 border border-Gray-150">
                <a
                  href="https://www.instagram.com/2mnordic/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Instagram"
                >
                  <InstagramFill
                    className="cursor-pointer"
                    width="20"
                    height="20"
                  />
                </a>
              </div>
              <div className="bg-white rounded-lg px-3 py-3 mx-1 border border-Gray-150">
                <a
                  href="https://www.linkedin.com/company/2mnordic-it-consulting-ab/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Linkedin"
                >
                  <Linkedin className="cursor-pointer text-blue-700" />
                </a>
              </div>
            </div>
          </div>
          <div className="">
            {showSpinner ? (
              <div className="py-20">
                {" "}
                <Spinner />
              </div>
            ) : (
              <div className="">
                {feedSource && feedSource.length > 0 ? (
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full md:px-0 px-5 py-5 md:py-10">
                    {renderFeedList}
                  </div>
                ) : (
                  <div className="md:text-4xl text-3xl font-semibold leading-normal text-blue-800 text-center font-avenirHeavy py-20">
                    No data found
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="bg-Gray-50 md:py-24 py-12 md:hidden block">
        <div className="container sm:container md:container lg:container w-full mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <h2 className="brand-secondary-gradient text-3xl md:text-5xl font-semibold leading-normal font-avenirHeavy md:pb-0 pb-6">
              #feeds
            </h2>
            <div className="flex flex-row items-center mb-6">
              <span className="text-blue-800 text-sm font-light pr-3">
                Follow us on
              </span>
              <div className="bg-white rounded-lg px-3 py-3 mx-2 border border-Gray-150">
                <a
                  href="https://www.facebook.com/2MNordic"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Facebook"
                >
                  <Facebook className="cursor-pointer text-blue-600" />
                </a>
              </div>
              <div className="bg-white rounded-lg px-3 py-3 mx-1 border border-Gray-150">
                <a
                  href="https://www.instagram.com/2mnordic/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Linkedin"
                >
                  <InstagramFill
                    className="cursor-pointer"
                    width="20"
                    height="20"
                  />
                </a>
              </div>
              <div className="bg-white rounded-lg px-3 py-3 mx-1 border border-Gray-150">
                <Linkedin className="cursor-pointer text-blue-700" />
              </div>
            </div>
          </div>

          {showSpinner ? (
            <div className="py-20">
              {" "}
              <Spinner />
            </div>
          ) : (
            <>
              {" "}
              {feedSource && feedSource.length > 0 ? (
                <Slider {...settings} className="px-5">
                  {renderFeedList}
                </Slider>
              ) : (
                <div className="py-20">No data found</div>
              )}
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default Feeds;
